module.exports = [
 {
  "start": 41,
  "end": 1542,
  "text": "Pickelporno was conceived "
 },
 {
  "start": 1625,
  "end": 4291,
  "text": "as a reaction to the anti-porno movement "
 },
 {
  "start": 4583,
  "end": 8333,
  "text": "and my urge to propose images of sexualities"
 },
 {
  "start": 8417,
  "end": 10583,
  "text": "rather than to analyse the pros "
 },
 {
  "start": 10625,
  "end": 12250,
  "text": "and the cons of pornography"
 },
 {
  "start": 12750,
  "end": 16458,
  "text": "if there is a general female interest "
 },
 {
  "start": 16500,
  "end": 20291,
  "text": "at all I guess it is to see subjective pictures "
 },
 {
  "start": 20417,
  "end": 23708,
  "text": "from just before and behind the eyelid of these people "
 },
 {
  "start": 23834,
  "end": 25667,
  "text": "involved in a kissing scene, "
 },
 {
  "start": 25708,
  "end": 28959,
  "text": "rather than seeing sex from a distant perspective"
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room3/audio3/03_3MCA Pickle Porrno.js